import { motion } from "framer-motion";

import { useStepperContext } from "./useStepper";

export interface StepperProgressBarProps {
  className?: string;
  value?: number;
}

export function StepperProgressBar({
  className = "w-full min-w-[200px] flex items-center gap-1",
  value,
}: StepperProgressBarProps) {
  const { step, totalSteps } = useStepperContext();

  const progress = value === undefined ? (step / totalSteps) * 100 : value;

  return (
    <div className={className}>
      <div className="h-2 w-full rounded-md bg-bg-quaternary overflow-hidden relative">
        <motion.div
          animate={{ width: `${progress}%` }}
          className="h-2 w-full rounded-md bg-bg-brand-solid absolute"
          initial={{ width: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        />
      </div>
    </div>
  );
}
